import {createThermometer} from './thermometer.js';

function validationError(error){
  const text=String(error?.message||'Invalid thermometer').slice(0,180);
  let field='thermometer';
  if(/name/i.test(text))field='name';
  else if(/typeKey/i.test(text))field='typeKey';
  else if(/channelCount/i.test(text))field='channelCount';
  else if(/vendor/i.test(text))field='vendor';
  else if(/model/i.test(text))field='model';
  return Object.freeze({field,message:text});
}

export function createThermometerFlow({store,isOnline=()=>globalThis.navigator?.onLine!==false}={}){
  if(!store?.create||!store?.edit||!store?.get)throw new TypeError('Thermometer store is required');

  function validate(input={}){
    try{
      const value=createThermometer(input);
      return Object.freeze({ok:true,value,errors:Object.freeze({})});
    }catch(error){
      const failure=validationError(error);
      return Object.freeze({
        ok:false,
        value:null,
        errors:Object.freeze({[failure.field]:failure.message})
      });
    }
  }

  async function save(input={}, {id=null}={}){
    const candidate=id?{...input,id}:{...input};
    const checked=validate(candidate);
    if(!checked.ok)return Object.freeze({ok:false,status:'validation_error',errors:checked.errors,retryable:false});

    try{
      const saved=id
        ?await store.edit(id,{
          name:checked.value.name,
          typeKey:checked.value.typeKey,
          vendor:checked.value.vendor,
          model:checked.value.model,
          channelCount:checked.value.channelCount
        })
        :await store.create(checked.value);

      return Object.freeze({
        ok:true,
        status:isOnline()?'saved_pending_sync':'saved_offline',
        thermometerId:saved.id,
        saved
      });
    }catch(error){
      return Object.freeze({
        ok:false,
        status:String(error?.message)==='THERMOMETER_CONFLICT'?'conflict':'save_failed',
        errorCode:String(error?.code||error?.message||'THERMOMETER_SAVE_FAILED').slice(0,80),
        retryable:true
      });
    }
  }

  async function load(id){
    const value=await store.get(id);
    if(!value)throw new TypeError('Thermometer not found');
    return createThermometer(value);
  }

  return Object.freeze({validate,save,load});
}
